import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'machine';

class MachineCache {
  constructor() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  async fetchData(forceRefresh = false) {
    if (globalCacheManager.isRefreshing) {
      return this.data || [];
    }

    if (!forceRefresh && this.data) {
      return this.data;
    }

    if (this.pendingPromise && !forceRefresh) {
      return this.pendingPromise;
    }

    this.pendingPromise = (async () => {
      try {
        await globalCacheManager.refreshFromBundle(forceRefresh);
        return this.data || [];
      } catch (error) {
        console.error('[MachineCache] Error refreshing from bundle:', error);
        return this.data || [];
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data || [];
    this.lastFetchTime = Date.now();
  }

  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

const machineCache = new MachineCache();

globalCacheManager.register(CACHE_KEY, machineCache);

export const fetchMachineListCached = async (forceRefresh = false) => {
  return await machineCache.fetchData(forceRefresh);
};

export const getMachineListCached = () => {
  return machineCache.getData();
};

export const invalidateMachineCache = () => {
  machineCache.invalidate();
};

export default machineCache;
